export default __webpack_public_path__ + "static/media/05.6642d3b0.jpg";